export default __webpack_public_path__ + "static/media/nft.f5f81040.svg";